import { createContext } from "react";
import { Blocker } from "react-router-dom";

import { Encounter } from "@medplum/fhirtypes";

interface EncounterContextOptions {
  encounter: Encounter | undefined;
  setEncounter: (encounter: Encounter) => void;
  gestationalAgeWeeks?: number | undefined;
  registerUnsavedCheck?: (key: string, checkFn: () => boolean) => void;
  unregisterUnsavedCheck?: (key: string) => void;
  blocker?: Blocker;
}

export const EncounterContext = createContext<EncounterContextOptions>(
  {} as EncounterContextOptions,
);
